import { createSelector } from '@ngrx/store';

import { menuFlowsState } from '../root';

export const getMenuFlows = createSelector(
    menuFlowsState, (menuFlows) => menuFlows
);
